export const _globalThis = typeof globalThis === "object" ? globalThis : global;
